/* eslint-disable */
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

import mixitup from 'mixitup';

export default {
  init() {
    let e = $('#countDownTimer');

    let eVal = e.attr('value');
    function countdownTimer(endTime) {
      const targetTime = new Date(endTime).getTime();

      const timer = setInterval(() => {
        const now = new Date().getTime();
        const timeRemaining = targetTime - now;

        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        // console.clear(); // Clears the console (optional)

        // console.log(
        //   `Time Remaining: ${days} days ${hours} hours ${minutes} minutes ${seconds} seconds`
        // );

        if (timeRemaining <= 0) {
          clearInterval(timer);
          console.log('Countdown finished!');
        } else {
          e.html(
            `הזמן שנותר: ${days} ימים ${hours} שעות ${minutes} דקות ${seconds} שניות`
          );
        }
      }, 1000);
    }

    if (eVal) {
      // Example usage: Countdown to May 31, 2023, 12:00 PM
      countdownTimer(eVal);
    }

    const button = document.querySelector('.play-button');
    const video = document.querySelector('.header-video');

    // button.addEventListener("click", (e) => {
    video.style.display = 'block';
    video.play();
    // });

    const graduatesListElement = document.querySelector('.content-main-list');
    if (graduatesListElement) {
      const graduatesListElementChildren = Array.prototype.slice.call(
        graduatesListElement.children
      );

      let i = 0;
      let currentChildren = graduatesListElementChildren[i];
      const galleryInterval = setInterval(() => {
        if (i === graduatesListElementChildren.length - 1) i = 0;
        else i++;
        currentChildren = graduatesListElementChildren[i];
        graduatesItemFunc(currentChildren, graduatesListElementChildren);
      }, 3000);

      graduatesListElementChildren.forEach((graduatesItem) => {
        graduatesItem.addEventListener('click', () => {
          clearInterval(galleryInterval);
          graduatesItemFunc(graduatesItem, graduatesListElementChildren);
        });
      });

      const topContentListItem = document.querySelectorAll(
        '.top-content-list-item .title'
      );

      topContentListItem.forEach((element) => {
        element.addEventListener('click', () => {
          if (element.nextElementSibling.classList.contains('invisible')) {
            element.nextElementSibling.classList.remove('invisible');
          } else {
            element.nextElementSibling.classList.add('invisible');
          }
        });
      });

      graduatesListElement.firstElementChild.classList.add('active');
    }

    $(window).load(() => {
      checkIfYPositionAndAnimate();
      window.checkIfYPositionAndAnimate = checkIfYPositionAndAnimate;
      document.addEventListener('scroll', checkIfYPositionAndAnimate);

      if (window.innerWidth > 768) {
        video.src = videoDesktop;
      } else {
        video.src = videoMobile;
      }

      $('.wpcf7-form').on('submit', function (event) {
        window.dataLayer.push({
          event: 'custom.event.online.user.experience.register.submit',
          'custom.gtm.element': event.target,
          'custom.gtm.elementClasses': event.target.className || '',
          'custom.gtm.elementId': event.target.id || '',
          'custom.gtm.elementTarget': event.target.target || '',
          'custom.gtm.elementUrl':
            event.target.href || event.target.action || '',
          'custom.gtm.originalEvent': event,
        });

        return true;
      });

      new Swiper('.not-people-of-words', {
        // If we need pagination
        pagination: {
          el: '.not-people-of-words .swiper-pagination',
        },

        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide: 1,
      });

      new Swiper('.content-mobile', {
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide: 1,
        pagination: {
          el: '.content-mobile .swiper-pagination',
        },
        autoplay: {
          delay: 3000,
        },
      });

      new Swiper('.items-mobile', {
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide: 1,
        pagination: {
          el: '.items-mobile .swiper-pagination',
        },
      });

      mixitup('.syllabus-items-list', {
        selectors: {
          target: 'div.syllabus-item',
          control: '.syllabus-filter',
        },
        animation: {
          effectsIn: 'fade translateY(-100%)',
          animateResizeContainer: false,
        },
      }).filter('.syllabus-0');

      // Courses periods
      mixitup('.upcoming-courses-items', {
        selectors: {
          target: 'div.upcoming-course-item',
          control: '.courses-filter',
        },
        animation: {
          effectsIn: 'fade translateY(-100%)',
        },
      }).filter('.courses-0');
    });

    // $(window).load(() => {
    //   const syllabusCat = $('.syllabus-items-categories .item-category.force');
    //
    //   if (syllabusCat.length) {
    //     const idx = syllabusCat.data('idx');
    //     $(`.syllabus-items-list .syllabus-item[data-idx=${idx}]`).show();
    //   }
    // });

    // $('.syllabus-items-categories .item-category').on('click', function (e) {
    //   e.preventDefault();
    //
    //   const idx = $(this).data('idx');
    //
    //   $('.syllabus-items-categories .item-category').not($(this))
    //     .removeClass('active');
    //
    //   $(this).addClass('active');
    //
    //   $(`.syllabus-items-list .syllabus-item`).hide();
    //   $(`.syllabus-items-list .syllabus-item[data-idx=${idx}]`).show();
    // });

    // Faq Questions
    $('.course-faq .faq-items-wrap .question-item .question-item-head').on(
      'click',
      function () {
        const item = $(this).parent();

        $('.question-item')
          .not(item)
          .removeClass('active')
          .find('.question-item-body')
          .slideUp(200);

        item.toggleClass('active');
        item.find('.question-item-body').stop().slideToggle(200);
      }
    );

    // Mobile who fits toggle
    $('.who-fits-blocks .fits-block-item .block-title').on(
      'click',
      function () {
        if ($(window).width() > 767) {
          return;
        }

        const item = $(this).parent();

        $('.fits-block-item')
          .not(item)
          .removeClass('active')
          .find('.block-info')
          .slideUp(200);

        item.toggleClass('active');
        item.find('.block-info').stop().slideToggle(200);
      }
    );
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

const checkIfYPositionAndAnimate = () => {
  const percentageElement = document.querySelector(
    '.not-people-of-words-container'
  );

  if (window.scrollY >= percentageElement.offsetTop - 400) {
    const circles = document.querySelectorAll('.circle');
    circles.forEach((circle) => {
      const percent = circle.dataset.percent;
      let i = 1;

      const interval = setInterval(() => {
        circle.classList.remove('p' + i - 1);
        circle.classList.add('p' + i);
        i++;

        if (i > 51) {
          circle.querySelector('.fill').style.display = 'initial';
        }

        circle.querySelector('span').innerHTML = `${i}%`;

        if (i == percent) {
          // console.log(percent);
          clearInterval(interval);
        }
      }, 5);
    });

    document.removeEventListener('scroll', window.checkIfYPositionAndAnimate);
  }
};

function graduatesItemFunc(graduatesItem, graduatesListElementChildren) {
  if (graduatesItem.classList.contains('active')) {
    return graduatesItem.classList.remove('active');
  }

  graduatesListElementChildren.forEach((ele) => ele.classList.remove('active'));
  graduatesItem.classList.add('active');

  const idx = graduatesItem.dataset.idx;
  const boxes = Array.prototype.slice.call(
    document.querySelectorAll(`.content-main-item`)
  );
  boxes.forEach((ele) => (ele.style.display = 'none'));
  const boxToDisplay = boxes.find((ele) => ele.dataset.idx === idx);
  // console.log(boxToDisplay, 'where');
  boxToDisplay.style.display = 'flex';
}



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateNewLandingPage.js